import ThumbExistingBucket from './thumbExistingBucket';
import QuoteProductThumbDetailDiagram from './quoteProductThumbDetailDiagram';
import ThumbBucketLocationType from './thumbBucketLocationType';

export default class QuoteProductDetail {
  constructor(item) {
    if (item) {
      this.bucketLocation = item.bucketLocation;
      this.bucketQuoteProductId = item.bucketQuoteProductId;
      this.existingBucketSpecsAvailable = item.existingBucketSpecsAvailable;
      this.existingBucketSpecsNotAvailableAcknowledgedByUserId =
        item.existingBucketSpecsNotAvailableAcknowledgedByUserId;
      this.existingBucketSpecsNotAvailableAcknowledgedByUserName =
        item.existingBucketSpecsNotAvailableAcknowledgedByUserName;
      this.existingBucketSpecsNotAvailableAcknowledgedDate =
        item.existingBucketSpecsNotAvailableAcknowledgedDate;
      this.existingBucket = item.existingBucket
        ? new ThumbExistingBucket(item.existingBucket)
        : null;
      this.isEdit = item.isEdit ? item.isEdit : false;
      this.tineDiagram = item.tineDiagram
        ? new QuoteProductThumbDetailDiagram(item.tineDiagram)
        : null;
      this.tipRadiusDiagram = item.tipRadiusDiagram
        ? new QuoteProductThumbDetailDiagram(item.tipRadiusDiagram)
        : null;
      this.thumbTipRadius = item.thumbTipRadius;
      return;
    }
    this.bucketLocation = null;
    this.bucketQuoteProductId = null;
    this.existingBucketSpecsAvailable = null;
    this.existingBucketSpecsNotAvailableAcknowledgedByUserId = null;
    this.existingBucketSpecsNotAvailableAcknowledgedDate = null;
    this.existingBucket = null;
    this.isEdit = true;
    this.tineDiagram = null;
    this.tipRadiusDiagram = null;
    this.thumbTipRadius = null;
  }

  noBucketSpecsAvailable() {
    return (
      this.bucketLocation == ThumbBucketLocationType.ExistingQuote &&
      !this.existingBucketSpecsAvailable
    );
  }
}
